import { type ComponentPropsWithRef, memo, use } from "react"

import { MentionListContext } from "./context"

type MentionListEmptyProps = ComponentPropsWithRef<"div">

export const MentionListEmpty = memo<MentionListEmptyProps>((props) => {
	const { children } = props

	const { empty } = use(MentionListContext)

	return empty && <div>{children}</div>
})
MentionListEmpty.displayName = "MentionListEmpty"
